import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class FootPrintPortalManager_ds_orders_dashboardService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { fullTextSearch?: string, ownerId?: number, projectId?: number, warehouseIds: number[] }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, LookupCode?: string, Notes?: string, OrderClassId?: number, OrderStatusId?: number, OwnerReference?: string, PreferredWarehouseId?: number, ProjectId?: number, RequestedDeliveryDate?: string, OrderClass?: { LookupCode?: string, OrderClassTypeId?: number, OrderTypeId?: number }, Project?: { LookupCode?: string, Name?: string, Owner?: { LookupCode?: string, Name?: string } }, Status?: { Name?: string }, ShipmentOrderLookups?: { ShipmentId?: number, Shipment?: { WaveId?: number } }[], PreferredWarehouse?: { Id?: number, TimeZoneId?: string }, dock_appointment?: { Id?: number, DockAppointmentId?: number, DockAppointment?: { AssignedlLocationContainerId?: number, CheckedInOn?: string, LookupCode?: string, ScheduledArrival?: string, ScheduledDeparture?: string, ScheduledLocationContainerId?: number, StatusId?: number, TypeId?: number, WarehouseId?: number, Warehouse?: { TimeZoneId?: string }, AssignedLocation?: { Name?: string }, ScheduledLocation?: { Name?: string } }, convertedScheduledArrival?: { id?: number, convertedDate?: string }, convertedCheckInOn?: { id?: number, convertedDate?: string } } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.warehouseIds)) {
      missingRequiredInParams.push('\'warehouseIds\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/FootPrintPortalManager/datasources/ds_orders_dashboard/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { fullTextSearch?: string, ownerId?: number, projectId?: number, warehouseIds: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, LookupCode?: string, Notes?: string, OrderClassId?: number, OrderStatusId?: number, OwnerReference?: string, PreferredWarehouseId?: number, ProjectId?: number, RequestedDeliveryDate?: string, OrderClass?: { LookupCode?: string, OrderClassTypeId?: number, OrderTypeId?: number }, Project?: { LookupCode?: string, Name?: string, Owner?: { LookupCode?: string, Name?: string } }, Status?: { Name?: string }, ShipmentOrderLookups?: { ShipmentId?: number, Shipment?: { WaveId?: number } }[], PreferredWarehouse?: { Id?: number, TimeZoneId?: string }, dock_appointment?: { Id?: number, DockAppointmentId?: number, DockAppointment?: { AssignedlLocationContainerId?: number, CheckedInOn?: string, LookupCode?: string, ScheduledArrival?: string, ScheduledDeparture?: string, ScheduledLocationContainerId?: number, StatusId?: number, TypeId?: number, WarehouseId?: number, Warehouse?: { TimeZoneId?: string }, AssignedLocation?: { Name?: string }, ScheduledLocation?: { Name?: string } }, convertedScheduledArrival?: { id?: number, convertedDate?: string }, convertedCheckInOn?: { id?: number, convertedDate?: string } } }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.warehouseIds)) {
      missingRequiredInParams.push('\'warehouseIds\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/FootPrintPortalManager/datasources/ds_orders_dashboard/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { fullTextSearch?: string, ownerId?: number, projectId?: number, warehouseIds: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, CreatedSysDateTime?: string, LookupCode?: string, Notes?: string, OrderClassId?: number, OrderStatusId?: number, OwnerReference?: string, PreferredWarehouseId?: number, ProjectId?: number, RequestedDeliveryDate?: string, OrderClass?: { LookupCode?: string, OrderClassTypeId?: number, OrderTypeId?: number }, Project?: { LookupCode?: string, Name?: string, Owner?: { LookupCode?: string, Name?: string } }, Status?: { Name?: string }, ShipmentOrderLookups?: { ShipmentId?: number, Shipment?: { WaveId?: number } }[], PreferredWarehouse?: { Id?: number, TimeZoneId?: string }, dock_appointment?: { Id?: number, DockAppointmentId?: number, DockAppointment?: { AssignedlLocationContainerId?: number, CheckedInOn?: string, LookupCode?: string, ScheduledArrival?: string, ScheduledDeparture?: string, ScheduledLocationContainerId?: number, StatusId?: number, TypeId?: number, WarehouseId?: number, Warehouse?: { TimeZoneId?: string }, AssignedLocation?: { Name?: string }, ScheduledLocation?: { Name?: string } }, convertedScheduledArrival?: { id?: number, convertedDate?: string }, convertedCheckInOn?: { id?: number, convertedDate?: string } } }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.warehouseIds)) {
      missingRequiredInParams.push('\'warehouseIds\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/FootPrintPortalManager/datasources/ds_orders_dashboard/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }

}
